import React from 'react';
import PropTypes from 'prop-types';
import 'lazysizes';

import { defaultProductImageUrl } from '../../services/APIClient';
import ImageOverPlaceholder, { ASPECT_RATIOS } from '../ImageOverPlaceholder';

const BrandViewProductsItem = ({
  product,
  _onProductOpenClick,
}) => {
  const onProductOpenClick = () => _onProductOpenClick(product.slug);

  return (
    <div
      onClick={onProductOpenClick}
      tabIndex={0}
      role="link"
      className="column column-block"
      style={{
        cursor: 'pointer',
      }}
    >
      <ImageOverPlaceholder
        image={{
          url: (product.hero && product.hero.length)
            ? product.hero[0].mediaItem.url
            : defaultProductImageUrl,
          width: 500,
          height: 500,
        }}
        placeholder={defaultProductImageUrl}
        aspectRatio={ASPECT_RATIOS.SQUARE}
        className="mb-s"
        borderRadius=".20972rem"
      />
      <div className="row align-center collapse">
        <div className="columns text-center">
          <h6 className="fs-base">{product.name}</h6>
        </div>
      </div>
    </div>
  );
};

BrandViewProductsItem.propTypes = {
  _onProductOpenClick: PropTypes.func.isRequired,
  product: PropTypes.shape({}).isRequired,
};

export default BrandViewProductsItem;
